<template>
  <div class="project-detail">
    <!-- 详情头部开始 -->
    <div class="header" :class="{ 'no-remark': !(!!projectInfo.remark) }">
      <!-- 头部操作栏开始 -->
      <div class="header-action">
        <div class="header-edit" @click="handleEditProject">{{$t('common.edit')}}</div>
        <div class="header-setting" @click="handleSetting">{{$t('projectDetailsV2.setting')}}</div>
        <el-popover trigger="click" placement="bottom" :visible-arrow='false'
                    :ref="`project-${$route.query.id}`" @after-leave="downloadHide"
                    popper-class="project-download">
          <el-cascader-panel :props='props' v-model="downloadStr"
                             :options="projectOptionChange(projectOptions)"
                             @change='downloadProject($event)'></el-cascader-panel>
          <div class="header-download" slot="reference">{{$t('common.download')}}</div>
        </el-popover>
        <div class="header-statistics" @click="handleProjectStatistics">
          {{$t('projectDetailsV2.statistics')}}</div>
        <div class="header-del" @click="handleDelProject">{{$t('common.del')}}</div>
      </div>
      <!-- 头部操作栏结束 -->
      <div class="header-step">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ 'name': 'fileList' }">{{$t('projectDetailsV2.itemManage')}}
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('projectDetailsV2.projectDetails')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 项目名称状态 -->
      <div class="header-title">
        <el-tooltip popper-class="project-name-tooltip" effect="dark"
                    :disabled="projectNameTooltipVisible" :content="projectInfo.name"
                    placement="top">
          <span class="project-name"><span
                  @mouseover="projectNameMouseover($event)">{{projectInfo.name}}</span></span>
        </el-tooltip>
        <span
              :class="`status status-${finishFormat(projectInfo)}`">{{statusProjectFormat(projectInfo)}}</span>
        <!-- 进度条 -->
        <div class="header-progress">
          <el-progress :percentage="projectInfo.progress || 0"></el-progress>
        </div>
      </div>
      <!-- 详情 languageDirection-->
      <ul class="header-detail">
        <li>{{$t('projectDetailsV2.languageDirection')}}：
          <span v-if="$i18n.locale === 'zh'">{{projectInfo.sourceLangName}} —
            {{projectInfo.targetLangName}}</span>
          <span v-else>{{$langCase[projectInfo.sourceLang]}} —
            {{$langCase[projectInfo.targetLang]}}</span>
        </li>
        <li>{{$t('common.domainBlank')}}：
          <span v-if="$i18n.locale === 'zh'">{{projectInfo.domain}}</span>
          <span v-else>{{$domainCase[projectInfo.domainCode]}}</span>
        </li>
        <li>{{$t('newProjectV2.workFlow')}}：
          <span>
            <template v-if="projectInfo.projectProcessType >= 1">
              {{$t('projectV2.translate')}}
            </template>
            <template v-if="projectInfo.projectProcessType >= 2">
              <img
                   src="./assets/images/view_language_icon_direction.png" />{{$t('projectV2.examine')}}
            </template>
            <template v-if="projectInfo.projectProcessType >= 3">
              <img
                   src="./assets/images/view_language_icon_direction.png" />{{$t('projectV2.review')}}
            </template>
          </span>
        </li>
        <li>{{$t('newProjectV2.founder')}}：<span>{{projectInfo.creator}}</span></li>
        <li>{{$t('projectV2.createTime')}}：<span>{{projectInfo.createTime}}</span></li>
        <li>{{$t('projectV2.limitTime')}}：<span>{{projectInfo.deliveryTime}}</span></li>
      </ul>
      <div class="header-remark" v-show="projectInfo.remark">
        {{$t('newProjectV2.remark') + '：'}}<span>{{projectInfo.remark}}</span> </div>
    </div>
    <!-- 详情头部结束 -->

    <div class="content" :class="{ 'no-remark': !(!!projectInfo.remark) }">
      <!-- 左边文件内容开始 -->
      <div class="file-content">
        <div class="file-top">
          <el-button type="primary" size="small" @click="handleUploadFile">
            {{$t('projectDetailsV2.upload')}}</el-button>
          <el-input v-model="projectSearch" @blur="handleSearchProject"
                    @keyup.native.enter="handleSearchProject" size="small" clearable
                    @change="searchChange" :placeholder="$t('projectDetailsV2.search')"></el-input>
        </div>
        <div class="file-list">
          <div class="file-wrap">
            <div class="file-item" @click="selectFile(item)" v-for="item in fileList" :key="item.id"
                 :class="{ 'file-item-active' : item.id === activeFile.id }">
              <div :class="`file-name icon-${item.fileSuffix.toLocaleLowerCase()}`">
                <el-tooltip effect="dark" :content="item.name" placement="top">
                  <div class="name" @click="handlePreview(item)">{{ item.name }}</div>
                </el-tooltip>
                <div :class="`file-status status-${item.finish}`" v-if="item.status === 1">
                  {{ statusFormat(item.finish) }}
                </div>
                <div @click.stop="handleClick(`popover-${item.id}`)">
                  <el-popover placement="right" trigger="click" popper-class="setting-list"
                              :ref="`popover-${item.id}`" @after-leave="downloadHide">
                    <el-cascader-panel :options="fileOptionChange(options, item)" :props='props'
                                       v-model="downloadStr" @change='downloadFile($event, item)'>
                    </el-cascader-panel>
                    <div slot="reference" v-show="[0, 1].includes(item.status)"
                         class="file-setting"><span class="more-icon"></span></div>
                  </el-popover>
                </div>
              </div>
              <!-- 文件解析成功内容开始 -->
              <div class="file-info" v-if="item.status === 1">
                <div>{{$t('assignTaskV2.container')}}：<span
                        class="file-size">{{ item.fileSize ? `${(item.fileSize / 1024).toFixed(2)}KB` : '--KB' }}</span>
                </div>
                <div>{{$t('assignTaskV2.numberSentence')}}：<span
                        class="file-size">{{ item.sentCount }}</span></div>
                <div>{{$t('assignTaskV2.fontNumber')}}：<span
                        class="file-size">{{ item.sourceWordNum }}</span></div>
              </div>
              <div class="file-progress" v-if="item.status === 1">
                <el-progress :percentage="item.progress"></el-progress>
              </div>
              <div class="watermark" v-if="item.finish === 0 && item.status === 1">
                <div class="watermark-text-1">预翻译</div>
                <div class="watermark-text-2">完成</div>
              </div>
              <!-- <span v-if="item.finish === 0 && item.status === 1"
                    class="pre-trans-complete">{{$t('projectDetailsV2.preTransCompletion')}}</span> -->
              <!-- 文件解析成功内容结束 -->
              <!-- 文件解析失败内容开始 -->
              <div class="file-fail" v-if="item.status === 0">
                {{$t('projectDetailsV2.fileParsingFailure')}}</div>
              <!-- 文件解析失败内容结束 -->
              <div class="file-parsing" v-if="item.status > 1"><i class="el-icon-loading"
                   style="margin-right: 5px;"
                   v-if="item.readyProgress > 0"></i>{{ item.sourceWordNum }}
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- 右边文件内容结束 -->
      <div class="task-content">
        <TaskTabs :activeFile="activeFile" :projectInfo="projectInfo"
                  v-show="JSON.stringify(activeFile) !== '{}'"></TaskTabs>
        <div class="task-empty" v-show="JSON.stringify(activeFile) === '{}'">
          <span>{{$t('projectDetailsV2.selFileTip')}}</span>
        </div>
      </div>
    </div>

    <!-- 文件删除弹窗 -->
    <DelDialog width="480px" :dialogVisible="delVisible" :dialogType="'delete'"
               @handleClose="closeDel" @handleConfirm="delFile">
      {{$t('projectDetailsV2.confirmDeletion')}}</DelDialog>

    <!-- 项目删除弹窗 -->
    <DelDialog width="480px" :dialogVisible="delProjectVisible" :dialogType="'delete'"
               @handleClose="closeDelProject" @handleConfirm="delProject">
      {{$t('projectV2.delProjectTip')}}</DelDialog>

    <!-- 上传文件 -->
    <UploadFile :fileList="fileList" :createObj="{ 'langDesc': projectInfo.langDesc }"
                :uploadFileVisible="uploadFileVisible" @uploadFileCancel="uploadFileCancel"
                @updateFileList="updateFileList"></UploadFile>

    <!-- 上传答案 -->
    <UploadAnswer :updateFileInfo="updateFileInfo" :uploadAnswerVisible="uploadAnswerVisible"
                  @uploadAnswerCancel="uploadAnswerCancel"></UploadAnswer>

    <!-- 更新原文 -->
    <UpdateFile :updateFileInfo="updateFileInfo" :updateFileVisible="updateFileVisible"
                @updateFileCancel="updateFileCancel" @updateFile="updateFileList"></UpdateFile>

    <!-- 编辑项目 -->
    <EditProject :visible="editProjectVisible" :editProject="editProjectInfo"
                 @handleCancel="editProjectCancel" @updateProjectInfo="updateProjectInfo">
    </EditProject>

    <div v-show="isDownloadLoading" id="downloadLoadingBox">
      <div class="loadingMain">
        <i class="el-icon-loading"></i>
        <p>{{$t('projectDetailsV2.downloading')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import DelDialog from '@/components/delDialog';
import UploadFile from '@/components/fileDialog/uploadFile';
import UpdateFile from '@/components/fileDialog/updateFile';
import UploadAnswer from '@/components/fileDialog/uploadAnswer';
import EditProject from '@/components/projectDialog/editProject';
import TaskTabs from './module/TaskTabs';

import {
  deleteProject
} from '@/services/myProjectApi';

import {
  downloadAsyncV2,
  checkTransStatus,
  exportTransFileXlf,
  exportTransFileTmx,
  queryProjectDetails,
  exportAsyncTransFile,
  deleteFileByProjectID,
  getDownloadAsyncResult,
  getDownloadAsyncResultV2,
  queryFilePageByProjectID
} from '@/services/projectDetailsApi';

import { apiRoot } from '@/services/ajax';

export default {
  name: 'ProjectDetail',
  components: {
    TaskTabs,
    DelDialog,
    UploadFile,
    UpdateFile,
    EditProject,
    UploadAnswer
  },
  data() {
    return {
      IS_SCORE: IS_SCORE,
      projectSearch: '',
      fileList: [],
      activeFile: {},
      projectInfo: {},
      delVisible: false,
      delProjectVisible: false,
      delFileID: 0,
      options: [
        { label: this.$t('assignTaskV2.previsualization'), value: 'preview' },
        {
          label: this.$t('projectDetailsV2.download'),
          value: 'download',
          children: [
            { label: this.$t('projectV2.original'), value: 6 },
            {
              label: this.$t('projectV2.translate'), value: 'translate', children: [
                { label: this.$t('projectV2.translation'), value: 1 },
                { label: this.$t('projectV2.contrast'), value: 2 }
              ]
            },
            {
              label: this.$t('projectV2.examine'), value: 'proofread', children: [
                { label: this.$t('projectV2.translation'), value: 3 },
                { label: this.$t('projectV2.contrast'), value: 4 }
              ]
            },
            {
              label: this.$t('projectV2.review'), value: 'review', children: [
                { label: this.$t('projectV2.translation'), value: 11 },
                { label: this.$t('projectV2.contrast'), value: 12 }
              ]
            },
            { label: this.$t('projectV2.revise'), value: 5 },
            { label: this.$t('projectV2.xlfreport'), value: 'XLF' },
            { label: this.$t('projectV2.archive'), value: 'TMX' },
            { label: this.$t('projectV2.qareport'), value: 'QA' },
          ]
        },
        { label: this.$t('projectDetailsV2.uploadAnswer'), value: 'uploadAnswer' },
        { label: this.$t('projectDetailsV2.update'), value: 'update' },
        { label: this.$t('newProjectV2.del'), value: 'delete' }
      ],
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      projectOptions: [
        { label: this.$t('projectV2.original'), value: 'original' },
        {
          label: this.$t('projectV2.translate'),
          value: 'translate',
          children: [
            { label: this.$t('projectV2.translation'), value: 'translate-translation' },
            { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
          ]
        },
        {
          label: this.$t('projectV2.examine'),
          value: 'proofread',
          children: [
            { label: this.$t('projectV2.translation'), value: 'proofread-translation' },
            { label: this.$t('projectV2.contrast'), value: 'proofread-contrast' }
          ]
        },
        {
          label: this.$t('projectV2.review'),
          value: 'review',
          children: [
            { label: this.$t('projectV2.translation'), value: 'review-translation' },
            { label: this.$t('projectV2.contrast'), value: 'review-contrast' }
          ]
        },
        { label: this.$t('projectV2.revise'), value: 'modify' },
        { label: this.$t('projectV2.archive'), value: 'TMXreport' },
        { label: this.$t('projectV2.qareport'), value: 'QAreport' },
        { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
      ],
      downloadStr: '',
      isDownloadLoading: false,
      uploadFileVisible: false,
      uploadAnswerVisible: false,
      updateFileVisible: false,
      updateFileInfo: {},
      editProjectInfo: {},
      editProjectVisible: false,
      timeOut: null,
      downloadFileName: '',
      totalRows: '',
      projectNameTooltipVisible: false,
    }
  },
  async mounted() {
    await this.getProjectInfo();
    await this.getFileList();
    this.tableOut();
    // 找到第一个解析完成的文件并选中
    this.updateActiveFile();
    // this.$nextTick(() => {
    //   const domList = document.querySelectorAll('.project-detail .file-item')
    //   console.log(domList);
    //   Array.from(domList).forEach(item => {
    //     Watermark.set('预翻译成功', item)
    //   })
    //   // file-item
    //   // Watermark.set('高校党政云记录管理平台 ' + this.name, this.$refs.directrecordwp)
    // })
  },
  destroyed() {
    this.clear();
  },
  methods: {
    searchChange(val) {
      if (val === '') {
        this.getFileList();
      }
    },
    handlePreview(row) {
      if (parseInt(row.transModel) === 1 && row.isSplit) {
        return;
      }
      if (row.status === 0) {
        this.$message.closeAll();
        this.$message({
          message: row.remark || this.$t('projectDetailsV2.fileParsingFailure'),
          type: "warning",
        });
        return;
      }
      if (row.status > 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('projectDetailsV2.fileParsingNotEdit'),
          type: "warning",
        });
        return;
      }
      let userId = JSON.parse(localStorage.getItem("userInfo")).id;
      let obj = {};
      Reflect.set(obj, 'project', (row.finish));
      Reflect.set(obj, 'sourceLang', (row.sourceLang));
      Reflect.set(obj, 'targetLang', (row.targetLang));
      Reflect.set(obj, 'taskName', (row.name));
      Reflect.set(obj, 'userId', (userId || ''));
      Reflect.set(obj, 'wordNum', (row.sourceWordNum));
      Reflect.set(obj, 'transStatus', 2);
      Reflect.set(obj, 'isSplit', row.isSplit);
      Reflect.set(obj, 'langDesc', row.langDesc);
      Reflect.set(obj, 'taskType', 1);
      Reflect.set(obj, 'progress', row.progress);
      Reflect.set(obj, 'fileSuffix', row.fileUsableSuffix);
      Reflect.set(obj, 'transModel', row.transModel);
      Reflect.set(obj, 'taskCount', row.taskCount);
      Reflect.set(obj, 'finish', row.finish);
      sessionStorage.setItem("fileName", row.name)
      //老版参数
      Reflect.set(obj, 'fileId', (row.id));
      Reflect.set(obj, 'type', 'project');
      Reflect.set(obj, 'taskId', null);
      Reflect.set(obj, 'projectId', (row.projectId));
      let routeData = this.$router.resolve({
        path: "/neweditor",
        query: {
          key: this.$Base64.encode(
            JSON.stringify(obj)
          )
        }
      });
      window.open(routeData.href, "_self");
    },
    handleClick(pop) {
      document.body.click();
      this.$refs[pop][0].doShow()
    },
    async updateProjectInfo() {
      await this.getProjectInfo();
      // 为了更新项目时间后去更新未分配任务的截止时间
      this.bus.$emit('updateFileTask');
    },
    // 获取文件列表
    async getFileList() {
      let { list, success, totalRows } = await queryFilePageByProjectID({
        filter: {
          project_id: this.$route.query.id
        },
        page: 1,
        rows: 20,
        sort: {}
      });
      if (!success) return;
      this.totalRows = totalRows;
      list = list || [];
      list.forEach(item => {
        switch (item.status) {
          case 1:
            break;
          case 2:
            item.sourceWordNum = this.$t('projectDetailsV2.parsingQueuing') + ' ' + this.$t('projectDetailsV2.currentQueuePosition', [item.rankPosition]);
            break;
          case 3:
            item.sourceWordNum = this.$t('projectDetailsV2.parsing');
            break;
          case 4:
            item.readyProgress = item.readyProgress || 0;
            if (item.readyProgress === 0) {
              item.sourceWordNum = this.$t('projectDetailsV2.preTransQueuing');
            } else {
              let str = ` `;
              if ((item.timeRemaining!=null) && item.timeRemaining < 60) {
                str += this.$t('projectDetailsV2.estimatedRemainingTime', [item.timeRemaining]);
              } else {
                str += this.$t('projectDetailsV2.estimatedRemainingTimes', [(item.timeRemaining / 60).toFixed(1)]);
              }
              item.sourceWordNum = this.$t('projectDetailsV2.translating') + ` ${item.readyProgress}%` + str;
            }
            break;
          default:
            item.sourceWordNum = 0;
            break;
        }
      });
      this.fileList = list;
    },
    // 获取项目详情
    async getProjectInfo() {
      const { result, success } = await queryProjectDetails({
        id: this.$route.query.id
      });
      if (!success) return;
      this.projectInfo = result;
    },
    // 删除文件
    async delFile() {
      this.delVisible = false;
      let { success } = await deleteFileByProjectID({
        id: this.delFileID
      });
      if (!success) {
        this.$message.warning(this.$t('newProjectV2.delFail'));
        return;
      }
      this.$message.success(this.$t('newProjectV2.delSuccess'));
      await this.getFileList();
      if (this.isTime === "") {
        this.tableOut();
      }
      // 找到第一个解析完成的文件并选中
      if (this.delFileID === this.activeFile.id) {
        this.updateActiveFile();
      }
      this.delFileID = 0;
    },
    // 删除项目
    async delProject() {
      this.dialogVisible = false;
      let { success } = await deleteProject({ id: this.$route.query.id });
      this.$message.closeAll();
      if (!success) {
        this.$message.warning(this.$t('projectV2.error'));
        return;
      }
      this.$message.success(this.$t('projectV2.success'));
      this.$router.push({
        name: "projectHome"
      });
    },
    async handleSearchProject() {
      if (this.projectSearch === '') {
        return;
      }
      let { list, success } = await queryFilePageByProjectID({
        filter: {
          project_id: this.$route.query.id
        },
        page: 1,
        rows: 20,
        sort: {}
      });
      if (!success) return;
      list = list || [];
      list.forEach(item => {
        switch (item.status) {
          case 1:
            break;
          case 2:
            item.sourceWordNum = this.$t('projectDetailsV2.parsingQueuing') + ' ' + this.$t('projectDetailsV2.currentQueuePosition', [item.rankPosition]);
            break;
          case 3:
            item.sourceWordNum = this.$t('projectDetailsV2.parsing');
            break;
          case 4:
            item.readyProgress = item.readyProgress || 0;
            if (item.readyProgress === 0) {
              item.sourceWordNum = this.$t('projectDetailsV2.preTransQueuing');
            } else {
              let str = ` `;
              if ((item.timeRemaining!=null) && item.timeRemaining < 60) {
                str += this.$t('projectDetailsV2.estimatedRemainingTime', [item.timeRemaining]);
              } else {
                str += this.$t('projectDetailsV2.estimatedRemainingTimes', [(item.timeRemaining / 60).toFixed(1)]);
              }
              item.sourceWordNum = this.$t('projectDetailsV2.translating') + ` ${item.readyProgress}%` + str;
            }
            break;
          default:
            item.sourceWordNum = 0;
            break;
        }
      });
      this.fileList = list.filter(item => {
        return item.name.indexOf(this.projectSearch) !== -1;
      });
    },
    // 上传文件
    handleUploadFile() {
      this.$message.closeAll();
      if (new Date() > new Date(this.projectInfo.deliveryTime)) {
        this.$message.warning(this.$t('projectDetailsV2.cannotUploadFile'));
        return;
      }
      if (this.totalRows === 10) {
        this.$message.warning(this.$t('projectDetailsV2.maxFileNum', [10]));
        return;
      }
      this.uploadFileVisible = true;
    },
    uploadFileCancel() {
      this.uploadFileVisible = false;
    },
    uploadAnswerCancel() {
      this.uploadAnswerVisible = false;
    },
    updateFileCancel() {
      this.updateFileVisible = false;
    },
    // 删除文件
    deleteFile(item) {
      this.delFileID = item.id;
      this.delVisible = true;
    },
    // 删除项目
    handleDelProject() {
      this.delProjectVisible = true;
    },
    // 编辑项目
    handleEditProject() {
      this.editProjectInfo = { ...this.projectInfo };
      this.editProjectVisible = true;
    },
    // 关闭删除项目
    closeDelProject() {
      this.delProjectVisible = false;
    },
    // 关闭编辑项目
    editProjectCancel() {
      this.editProjectVisible = false;
    },
    // 关闭删除文件
    closeDel() {
      this.delVisible = false;
    },
    // 跳转设置
    handleSetting() {
      this.$router.push({
        name: 'DetailSetting',
        query: { id: this.$route.query.id }
      })
    },
    // 跳转统计
    handleProjectStatistics() {
      this.$router.push({
        name: 'ProjectStatistics',
        query: { id: this.$route.query.id }
      })
    },
    // 选中的文件
    selectFile(item) {
      this.$message.closeAll();
      if (item.status === 1) {
        this.activeFile = item;
      } else if (item.status === 0) {
        this.$message.warning(this.$t('projectDetailsV2.fileParsingFailure'));
      } else {
        this.$message.warning(item.sourceWordNum);
      }
    },
    // 找到第一个解析完成的文件并选中
    updateActiveFile() {
      this.activeFile = this.fileList.find(item => {
        return item.status === 1;
      }) || {};
    },
    // 更新列表
    async updateFileList() {
      await this.getFileList();
      this.tableOut();
    },
    tableOut() {
      let self = this;
      if (self.timeOut !== null) { return; }
      self.timeOut = window.setInterval(async () => {
        let list = self.fileList || [];
        let params = {
          transFileIdList: [],
          transProjectIdList: [],
        };
        list.forEach((item) => {
          if (item.status > 1) {
            params.transFileIdList.push(item.id);
          }
        });
        if (
          params.transFileIdList.length < 1 &&
          params.transProjectIdList.length < 1
        ) {
          await this.getProjectInfo();
          self.clear();
        } else {
          let { result, success } = await checkTransStatus(params);
          if (!success) {
            return;
          }
          if (result.transFileRespVoList != null) {
            result.transFileRespVoList.forEach((i) => {
              list.forEach((item) => {
                if (item.id === i.id) {
                  item.status = i.status;
                  if (JSON.stringify(self.activeFile) === '{}') {
                    self.updateActiveFile();
                  }
                  item.finish = i.finish || 0;
                  item.fileSize = i.fileSize;
                  item.sentCount = i.sentCount;
                  item.fileUsableSuffix = i.fileUsableSuffix;
                  switch (item.status) {
                    case 2:
                      item.sourceWordNum = self.$t('projectDetailsV2.parsingQueuing') + ' ' + self.$t('projectDetailsV2.currentQueuePosition', [i.rankPosition]);
                      break;
                    case 3:
                      item.sourceWordNum = self.$t('projectDetailsV2.parsing');
                      break;
                    case 4:
                      item.readyProgress = i.readyProgress || 0;
                      // 如果是 0 或者 null，显示为 预翻译排队中..2条回复
                      if (item.readyProgress === 0) {
                        item.sourceWordNum = self.$t('projectDetailsV2.preTransQueuing');
                      } else {
                        let str = ` `;
                        if ((i.timeRemaining!=null) && i.timeRemaining < 60) {
                          str += self.$t('projectDetailsV2.estimatedRemainingTime', [i.timeRemaining]);
                        } else {
                          str += self.$t('projectDetailsV2.estimatedRemainingTimes', [(i.timeRemaining / 60).toFixed(1)]);
                        }
                        item.sourceWordNum = self.$t('projectDetailsV2.translating') + ` ${item.readyProgress}%` + str;
                      }
                      break;
                    default:
                      item.sourceWordNum = i.sourceWordNum || 0;
                      break;
                  }
                }
              });
            });
          }
        }
      }, 3000);
    },
    clear() {
      this.isTime = "";
      clearInterval(this.timeOut);
      this.timeOut = null;
    },
    // 级联隐藏
    downloadHide() {
      this.downloadStr = '';
    },
    // 下载文件
    downloadFile(val, row) {
      console.log(val,row,'SSSSSSSSS');
      let id = row.id;
      let obj = Object();
      let routeData;
      this.$refs[`popover-${id}`][0].doClose();
      switch (val) {
        case 'preview':
          this.handlePreview(row)
          // if (parseInt(row.transModel) === 1 && row.isSplit) {
          //   return;
          // }
          // if (row.status === 0) {
          //   this.$message.closeAll();
          //   this.$message({
          //     message: row.remark || this.$t('projectDetailsV2.fileParsingFailure'),
          //     type: "warning",
          //   });
          //   return;
          // }
          // if (row.status > 1) {
          //   this.$message.closeAll();
          //   this.$message({
          //     message: this.$t('projectDetailsV2.fileParsingNotEdit'),
          //     type: "warning",
          //   });
          //   return;
          // }
          // Reflect.set(obj, 'projectId', (row.projectId));
          // Reflect.set(obj, 'fileId', (row.id));
          // Reflect.set(obj, 'type', 'project');
          // Reflect.set(obj, 'taskId', null);
          // routeData = this.$router.resolve({
          //   path: "/neweditor",
          //   query: {
          //     key: this.$Base64.encode(
          //       JSON.stringify(obj)
          //     )
          //   }
          // });
          // window.open(routeData.href, "_blank");
          break;
        case 'uploadAnswer':
          this.updateFileInfo = {
            id: id,
            name: row.name,
            finish: row.finish,
            fileSuffix: row.fileSuffix,
          };
          this.uploadAnswerVisible = true;
          break;
        case 'update':
          if (row.finish === 1) {
            this.$message.closeAll();
            this.$message.warning(this.$t('projectDetailsV2.fileFinishNotUpdate'));
            return;
          }
          this.updateFileInfo = {
            id: id,
            finish: row.finish
          };
          this.updateFileVisible = true;
          break;
        case 'delete':
          this.deleteFile(row);
          break;
        default:
          // if (row.finish === 0 && val !== 6) {
          //   this.$message.closeAll();
          //   this.$message.warning(this.$t('projectDetailsV2.fileNotBeginNotDownload'));
          //   return;
          // }
          switch (val) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 11:
            case 12:
              this.onDownload(val, id);
              break;
            case 'XLF':
              this.onDownloadXlf(id);
              break;
            case 'TMX':
              this.onDownloadTmx(id);
              break;
            case 'QA':
              this.qaDownload(8, id);
              break;
          }
          break;
      }
    },
    // 除QA外下载
    async onDownload(type, id) {
      let param = {
        type,
        fileId: id
      };
      let { resultCode, result } = await exportAsyncTransFile(param);
      if (resultCode !== "1") {
        return;
      }
      if (result.percent == 100) {
        this.downloadServerFile(result.fileName, result.downloadUrl)
      } else {
        this.isDownloadLoading = true;
        this.getDownloadAsyncResult(result.taskKey);
      }
    },
    // a链接下载
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      if (this.downloadFileName !== '') {
        fileName = this.downloadFileName;
      }
      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);
      this.downloadFileName = '';
      document.body.appendChild(link);
      link.click();
    },
    // 除QA外下载
    async getDownloadAsyncResult(taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResult({ taskKey });
        if (resultCode === "1") {
          if (parseInt(result.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.isDownloadLoading = false;
        }
      }, 2000);
    },
    async onDownloadXlf(id) {
      let { resultCode, result } = await exportTransFileXlf({ id });
      if (resultCode === '1') {
        window.open(result);
        this.isDownloadLoading = false;
      }
    },
    async onDownloadTmx(id) {
      let { resultCode, result } = await exportTransFileTmx({ id });
      if (resultCode === '1') {
        window.open(result);
        this.isDownloadLoading = false;
      }
    },
    // QA下载
    async qaDownload(type, id) {
      let param = {
        type,
        fileId: id
      };
      let { resultCode, result } = await downloadAsyncV2(param);
      if (resultCode !== "1") {
        return;
      }
      if (result.percent == 100) {
        this.downloadServerFile(result.downloadUrl, result.downloadUrl)
      } else {
        this.isDownloadLoading = true;
        this.getDownloadAsyncResultV2(result.taskKey);
      }
    },
    // QA异步下载
    async getDownloadAsyncResultV2(taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResultV2({ taskKey });
        if (resultCode === "1") {
          if (parseInt(result.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.isDownloadLoading = false;
        }
      }, 2000);
    },
    statusFormat(status) {
      if (status === 0) {
        return this.$t('projectDetailsV2.notBegin');
      } else if (status === 2) {
        return this.$t('projectDetailsV2.inProgress');
      } else if (status === 1) {
        return this.$t('projectDetailsV2.completed');
      } else if (status === 3) {
        return this.$t('projectDetailsV2.accepted');
      }
    },
    statusProjectFormat(row) {
      if (row.finish === 0) {
        if (new Date() > new Date(row.deliveryTime)) {
          return this.$t('projectDetailsV2.overdue');
        }
        return this.$t('projectDetailsV2.notBegin');
      } else if (row.finish === 2) {
        if (new Date() > new Date(row.deliveryTime)) {
          return this.$t('projectDetailsV2.overdue');
        }
        return this.$t('projectDetailsV2.inProgress');
      } else if (row.finish === 1) {
        if (new Date(row.finishTime) > new Date(row.deliveryTime)) {
          return this.$t('projectDetailsV2.overdueComplete');
        }
        return this.$t('projectDetailsV2.completed');
      } else if (row.finish === 3) {
        return this.$t('projectDetailsV2.overdue');
      } else if (row.finish === 4) {
        return this.$t('projectDetailsV2.overdueComplete');
      } else if (row.finish === 5) {
        return this.$t('projectDetailsV2.accepted');
      }
    },
    projectNameMouseover(e) {
      let parentWidth = e.target.parentNode.offsetWidth;
      let contentWidth = e.target.offsetWidth;
      this.projectNameTooltipVisible = contentWidth <= parentWidth;
    },
    finishFormat(row) {
      if (row.finish === 0) {
        if (new Date() > new Date(row.deliveryTime)) {
          return 3;
        }
        return 0;
      } else if (row.finish === 2) {
        if (new Date() > new Date(row.deliveryTime)) {
          return 3;
        }
        return 2;
      } else if (row.finish === 1) {
        if (new Date(row.finishTime) > new Date(row.deliveryTime)) {
          return 4;
        }
        return 1;
      } else if (row.finish === 5) {
        return 5;
      }
    },
    fileOptionChange(options, item) {
      let status = item.status;
      let downloadArr = [
        { label: this.$t('projectV2.original'), value: 6 },
      ]
      let type = item.projectProcessType;
      if (status === 0) {
        return [{ label: this.$t('newProjectV2.del'), value: 'delete' }];
      }
      if (type >= 1) {
        downloadArr.push(
          {
            label: this.$t('projectV2.translate'), value: 'translate', children: [
              { label: this.$t('projectV2.translation'), value: 1 },
              { label: this.$t('projectV2.contrast'), value: 2 }
            ]
          },
        )
      }
      if (type >= 2) {
        downloadArr.push(
          {
            label: this.$t('projectV2.examine'), value: 'proofread', children: [
              { label: this.$t('projectV2.translation'), value: 3 },
              { label: this.$t('projectV2.contrast'), value: 4 }
            ]
          },
        )
      }
      if (type === 3) {
        downloadArr.push(
          {
            label: this.$t('projectV2.review'), value: 'review', children: [
              { label: this.$t('projectV2.translation'), value: 11 },
              { label: this.$t('projectV2.contrast'), value: 12 }
            ]
          },
        )
      }
      downloadArr.push(
        { label: this.$t('projectV2.revise'), value: 5 },
        { label: this.$t('projectV2.xlfreport'), value: 'XLF' },
        { label: this.$t('projectV2.archive'), value: 'TMX' },
        { label: this.$t('projectV2.qareport'), value: 'QA' },
      );
      let optionArr = [
        { label: this.$t('assignTaskV2.previsualization'), value: 'preview' },
        {
          label: this.$t('projectDetailsV2.download'),
          value: 'download',
          children: downloadArr
        },
      ];
      // 有没有上传答案
      if (this.IS_SCORE) {
        optionArr.push({ label: this.$t('projectDetailsV2.uploadAnswer'), value: 'uploadAnswer' });
      }
      optionArr.push(
        { label: this.$t('projectDetailsV2.update'), value: 'update' },
        { label: this.$t('newProjectV2.del'), value: 'delete' }
      );
      return optionArr;
    },
    projectOptionChange(options) {
      let type = this.projectInfo.projectProcessType;
      if (type === 1) {
        return [
          { label: this.$t('projectV2.original'), value: 'original' },
          {
            label: this.$t('projectV2.translate'), value: 'translate', children: [
              { label: this.$t('projectV2.translation'), value: 'translate-translation' },
              { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
            ]
          },
          { label: this.$t('projectV2.revise'), value: 'modify' },
          { label: this.$t('projectV2.archive'), value: 'TMXreport' },
          { label: this.$t('projectV2.qareport'), value: 'QAreport' },
          { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
        ];
      } else if (type === 2) {
        return [
          { label: this.$t('projectV2.original'), value: 'original' },
          {
            label: this.$t('projectV2.translate'), value: 'translate', children: [
              { label: this.$t('projectV2.translation'), value: 'translate-translation' },
              { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
            ]
          },
          {
            label: this.$t('projectV2.examine'), value: 'proofread', children: [
              { label: this.$t('projectV2.translation'), value: 'proofread-translation' },
              { label: this.$t('projectV2.contrast'), value: 'proofread-contrast' }
            ]
          },
          { label: this.$t('projectV2.revise'), value: 'modify' },
          { label: this.$t('projectV2.archive'), value: 'TMXreport' },
          { label: this.$t('projectV2.qareport'), value: 'QAreport' },
          { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
        ];
      }
      return options;
    },
    downloadProject(value) {
      let id = this.$route.query.id;
      let type = null;
      this.$refs[`project-${id}`].doClose();
      switch (value) {
        case 'original':
          type = 6;
          this.downloadFileName = this.projectInfo.name + '（原文）.zip';
          break;
        case 'translate-translation':
          type = 1;
          this.downloadFileName = this.projectInfo.name + '（翻译译文）.zip';
          break;
        case 'translate-contrast':
          type = 2;
          this.downloadFileName = this.projectInfo.name + '（翻译原译对照）.zip';
          break;
        case 'proofread-translation':
          type = 3;
          this.downloadFileName = this.projectInfo.name + '（审校译文）.zip';
          break;
        case 'proofread-contrast':
          type = 4;
          this.downloadFileName = this.projectInfo.name + '（审校原译对照）.zip';
          break;
        case 'review-translation':
          type = 11;
          this.downloadFileName = this.projectInfo.name + '（复审译文）.zip';
          break;
        case 'review-contrast':
          type = 12;
          this.downloadFileName = this.projectInfo.name + '（复审原译对照）.zip';
          break;
        case 'modify':
          type = 5;
          this.downloadFileName = this.projectInfo.name + '（修订痕迹）.zip';
          break;
        case 'TMXreport':
          type = 7;
          this.downloadFileName = this.projectInfo.name + '（TMX文档）.zip';
          break;
        case 'QAreport':
          type = 8;
          this.downloadFileName = this.projectInfo.name + '（QA报告）.zip';
          break;
        case 'XLFreport':
          type = 10;
          this.downloadFileName = this.projectInfo.name + '（XLF文档）.zip';
          break;
        default:
          break;
      }
      // if (type !== 6 && this.projectInfo.finish === 0) {
      //   this.$message.closeAll();
      //   this.$message.warning(this.$t('projectV2.porjectNotBeginNotDownload'))
      //   return;
      // }
      this.asynchronizationDownload(`/api/v1//file/exportAsyncProject?type=${type}&projectId=${id}`);
    },
    // 下载（异步）
    async asynchronizationDownload(url) {
      const response = await this.catReq1Service(url, {}, 'get')
      if (response.resultCode === "1") {
        const result = response.result;
        if (response.result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl);
        } else {
          this.isDownloadLoading = true;
          this.getDownloadAsyncResult(result.taskKey)
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>

<style lang="less">
.setting-list,
.project-download {
  padding: 0;
  .el-cascader-panel {
    .el-cascader-menu {
      min-width: 130px;
      .el-scrollbar__wrap {
        // height: auto;
        ul {
          li {
            height: 32px;
            .el-icon-check {
              display: none;
            }
            .el-cascader-node__label {
              line-height: 32px;
            }
          }
        }
      }
    }
  }
  
}

// .setting-list {
//   .el-scrollbar__wrap {
//     height: 275px;
//   }
// }

.project-download {
  transform: translateX(-20%);
  .el-scrollbar__wrap {
    height: auto;
  }
  .el-cascader-menu:last-child {
    .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }
  .el-cascader-menu:first-child {
    .el-scrollbar__wrap {
      overflow-x: scroll;
    }
  }
}

#downloadLoadingBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  z-index: 1000;
  text-align: center;

  .loadingMain {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: #fff;
    i {
      font-size: 30px;
    }
  }
}
.project-name-tooltip {
  width: 200px;
}
</style>